import React from 'react';
import { toast } from 'react-toastify';
import { API } from 'aws-amplify';

const useExport = () => {
    const exportDownloadRef = React.useRef();
    const [exportDownload, setExportDownload] = React.useState('');
    const [doingAjax, setDoingAjax] = React.useState(false);

    const handleExport = async () => {
        let id = toast.loading('Exporting Cognito users...');
        setDoingAjax(true);

        try {
            let { downloadExport } = await API.post('ShipyardAPI', '/admin/export_users');

            toast.success('Export retrieved, downloading now.');
            setExportDownload(downloadExport);
        } catch (e) {
            toast.error('API failure.');
        } finally {
            toast.dismiss(id);
        }
    };

    const downloadInitiated = () => {
        setExportDownload('');
        setTimeout(() => setDoingAjax(false), 2500);
    };

    return { exportDownloadRef, exportDownload, doingAjax, handleExport, downloadInitiated };
};

export default useExport;
